import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';

export default class SettingClientComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.MyModel = [
            {
                field: "ProductId",
                desc: "Product Id",
                placeholder: "Product Id",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },
            {
                field: "ServicePackCode",
                desc: "Service Pack Code",
                placeholder: "Service Pack Code",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },
            {
                field: "ServicePackDescription",
                desc: "Service Pack Description",
                placeholder: "Service Pack Description",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },
            {
                field: "Amount",
                desc: "Amount e.g R 10.03",
                placeholder: "Amount e.g R 10.03",
                required: true,
                type: "text",
                readonly: false,
                staticValue: ""
            },
            {
                field: "AmountCode",
                desc: "AmountCode (without R and '.') e.g 1003 means R 10.03",
                placeholder: "AmountCode (without R and '.') e.g 1003 means R 10.03",
                required: true,
                type: "float",
                readonly: false,
                staticValue: ""
            },
       /*     {
                field: "Category",
                desc: "Category",
                placeholder: "Category",
                required: true,
                type: "option",
                readonly: false,
                options: [
                    {val: "Allnet bundle", desc: "Allnet bundle"},
                    {val: "FreeMe", desc: "FreeMe"},
                    {val: "Telkom bundle",desc:"Telkom bundle"},
                    {val: "Time based",desc:"Time based"},
                    {val:"LTE bundle",desc:"LTE bundle"},
                    {val:"Sms bundle",desc:"Sms bundle"}
                ]
            },*/
            {field:"category",desc:"Category",placeholder:"Category",required:true,type:"text",readonly:false,
                filter:true,filterTable:"bundlesCategory",filterKey:"name",filterValue:"name"},
            {
                field: "Position",
                desc: "Position",
                placeholder: "Position",
                required: true,
                type: "float",
                readonly: false,
                staticValue: ""
            },

        ];
        this.ModelName = "Bundles";
        this.Crum = "/crum"
        this.PrimaryKey = "org"
    }

    render() {
        return (


            <PageContentWallpaper {...this.props} >

                <div className="row">
                    <div className="col-xs-12">
                        <h2>Bundle List</h2>
                    </div>

                </div>

                <div className="row">
                    <div className="col-xs-12">
                        <AddingModel
                            MyModel={this.MyModel}
                            ModelName={this.ModelName}
                            ListDisplayKey={["ProductId", "ServicePackCode", "ServicePackDescription", "Amount", "AmountCode", "Category", "Position"]}
                            ListDeleteKey={[
                                {field: "productid", type: "string"},
                                {field: "servicepackcode", type: "string"},
                            ]}
                            Crum={this.Crum}
                            /*PrimaryKey={this.PrimaryKey}*/
                        />
                    </div>
                </div>


            </PageContentWallpaper>


        );
    }
}